import {FeatureToggle, isFeatureEnabled} from '@/helpers/featureToggle'
import {NotificationTypeEnum} from '@/types/NotificationTypeEnum'

export type NotificationTypeType = {
  id: string
  name: string
  type: NotificationTypeEnum
  isEnabled: () => boolean
}

export type fallsOnBankHolidayType = {
  name: string
}

export const notificationTypeConfig: NotificationTypeType[] = [
  {id: '1', name: 'JOURNEY_BUILDER.SEND_PUSH_WIDGET_LABEL', type: NotificationTypeEnum.sendPush, isEnabled: () => true},
  {
    id: '2',
    name: 'JOURNEY_BUILDER.SEND_SMS_WIDGET_LABEL',
    type: NotificationTypeEnum.sendSMS,
    isEnabled: () => isFeatureEnabled(FeatureToggle.rtnStepSendSMS),
  },
  {
    id: '3',
    name: 'JOURNEY_BUILDER.SEND_WHATSAPP_WIDGET_LABEL',
    type: NotificationTypeEnum.sendWhatsApp,
    isEnabled: () => isFeatureEnabled(FeatureToggle.rtnStepSendWhatsApp),
  },
  {
    id: '6',
    name: 'JOURNEY_BUILDER.SEND_EMAIL_WIDGET_LABEL',
    type: NotificationTypeEnum.sendEmail,
    isEnabled: () => isFeatureEnabled(FeatureToggle.rtnStepSendEmail),
  },
]

export const fallsOnBankHolidayConfig: fallsOnBankHolidayType[] = [
  {name: 'NOTIFICATION_BUILDER.BANK_HOLIDAY_SAME_DAY_OPTION'},
  {name: 'NOTIFICATION_BUILDER.BANK_HOLIDAY_NEXT_DAY_OPTION'},
]
